import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { DictionaryEntryModel, DictionaryModel, HxDictionaryService, jsonValidator, UiError, UiLabel } from 'hx-services';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { HxLabelEditComponent } from 'hx-components';
import { NzRadioComponent, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number';
import { NgIf } from '@angular/common';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';


@Component({
    selector: 'hc-add-entry-modal',
    templateUrl: './add-entry.modal.html',
    styleUrls: ['./add-entry.modal.less'],
  imports: [TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, NzInputDirective, HxLabelEditComponent, NzRadioGroupComponent, NzRadioComponent, NzInputNumberComponent, NgIf, NzAlertComponent, NzModalFooterDirective, NzButtonComponent, NzWaveDirective, TranslocoPipe]
})
export class AddEntryModal {
  data: {
    dictionary: DictionaryModel,
    parentEntry?: DictionaryEntryModel,
  } = inject(NZ_MODAL_DATA);

  form = new FormGroup({
    enabled: new FormControl<boolean | null>(null, Validators.required),
    code: new FormControl<string | null>(null, Validators.required),
    title: new FormControl<UiLabel | null>(null, Validators.required),
    attributes: new FormControl<string | null>(null, jsonValidator),
    seq: new FormControl<number | null>(null),
  });
  isLoading = {
    save: false,
  };

  constructor(
    public modalRef: NzModalRef,
    private dictionaryService: HxDictionaryService,
  ) {
  }

  async submitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      const formModel = this.form.value;
      if (!formModel.code || !formModel.title || formModel.enabled === null || formModel.enabled === undefined) {
        throw new UiError('form.required.fields');
      }

      try {
        this.isLoading.save = true;
        await this.dictionaryService.saveNewEntry(this.data.dictionary.id, {
          entries: [{
            enabled: formModel.enabled,
            code: formModel.code,
            title: formModel.title,
            seq: formModel.seq ?? undefined,
            attributes: formModel.attributes ? JSON.parse(formModel.attributes) : undefined,
            childEntries: [],
          }],
          parentId: this.data.parentEntry?.id,
        });
        this.modalRef.close('success');
      } finally {
        this.isLoading.save = false;
      }
    }
  }
}
